import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { backendApi } from "../../api/apiService";
import {
  FaVolumeUp,
  FaUserPlus,
  FaCalendarAlt,
  FaSearch,
  FaExclamationCircle,
} from "react-icons/fa";
import defaultImg from "../../images/defaultImg.png";
import BarChart from "./barChart1";
import BarChart2 from "./barChart2";
import BarChart3 from "./barChart3";
import BarChart4 from "./barChart4";
import BarChart5 from "./barChart5";
import BarChart6 from "./barChart6";
import { useNavigate } from "react-router-dom";
import { awsConfig } from "../../config";
import { useSelector } from "react-redux";
import moment from "moment";
import {
  FiCircle,
  FiCheckCircle,
  FiXCircle,
  FiClock,
  FiMinusCircle,
  FiMessageCircle,
  FiPlusCircle,
} from "react-icons/fi";
import { FcHighPriority } from "react-icons/fc";
import { ShimmerCategoryItem } from "react-shimmer-effects";
export default function DashboardMain() {
  const roleId = parseInt(window.localStorage.getItem("role_id"));
  const { userDetails, userData } = useSelector((state) => state.login);
  const isAdminRole = roleId === 1 || roleId === 2 || roleId === 5;
  const navigate = useNavigate();
  const [interviewList, setInterviewList] = useState([]);
  const [dashboardData, setDashboardData] = useState();
  const [seriesData, setSeriesData] = useState();
  const [categories, setCategories] = useState();
  const [seriesDataInterview, setSeriesDataInterview] = useState();
  const [categoriesInterview, setCategoriesInterview] = useState();
  const [seriesDataApplication, setSeriesDataApplication] = useState();
  const [categoriesApplication, setCategoriesApplication] = useState();
  const [seriesDataCandidate, setSeriesDataCandidate] = useState();
  const [categoriesCandidate, setCategoriesCandidate] = useState();

  const [leftSide, setLeftSide] = useState();
  const [candidateStatus, setCandidateStatus] = useState();
  const [portFolio, setPortFolio] = useState();
  const [openingStatus, setOpeningStatus] = useState([]);
  const [vacancyReport, setVacancyReport] = useState([]);

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("DashboardMenu").classList.add("active");
    }, 500);
    getDashboardInit();
    getDashboardDetails();
    getOpeningDashboard();
  }, []);

  const getDashboardInit = () => {
    var req = {
      functionName: "dashboard_init",
      site_id: localStorage.getItem("siteId"),
      sec_user_id: localStorage.getItem("userId"),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success === "1") {
        setInterviewList(response.interviewList);
      } else {
        console.log("Wrong username or password");
        return false;
      }
    });
  };

  const [loader, setloader] = useState(false)
  const getDashboardDetails = () => {
    var req = {
      functionName: "dashboardLanding",
      site_id: localStorage.getItem("siteId"),
      sec_user_id: localStorage.getItem("userId"),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success === "1") {
        setDashboardData(response);
        setloader(true)
        console.log(response, "data_dashboard");

        setSeriesData(response.applicationPerMonth.map((entry) => entry.cnt));
        setCategories(
          response.applicationPerMonth.map((entry) =>
            entry.formatted_month != null ? entry.formatted_month : ""
          )
        );
        setSeriesDataInterview(
          response.interviewShedule.map((entry) => entry.cnt)
        );
        setCategoriesInterview(
          response.interviewShedule.map((entry) =>
            entry.formatted_month != null ? entry.formatted_month : ""
          )
        );
        setSeriesDataApplication(
          response.recruiterPortfolio.map((entry) => entry.cnt)
        );
        setCategoriesApplication(
          response.recruiterPortfolio.map((entry) =>
            entry.full_name != null ? entry.full_name : ""
          )
        );
        setSeriesDataCandidate(
          response.candidateStatus.map((entry) => entry.cnt)
        );
        setCategoriesCandidate(
          response.candidateStatus.map((entry) =>
            entry.STATUS != null ? entry.STATUS : ""
          )
        );
        setLeftSide(response.leftSide);
        setCandidateStatus(response.candidateStatus);
        setPortFolio(response.recruiterPortfolio);
      } else {
        console.log("Wrong username or password");
        return false;
      }
    });
  };

  const viewNewVacancy = () => {
    navigate(`/schedule/createJobOpening`);
  };
  const viewNewCandidate = () => {
    navigate(`/fileUpload/resumeUpload`);
  };
  const viewNewInterviews = () => {
    navigate(`/schedule/schedules`);
  };
  const viewSearch = () => {
    navigate(`/dashboard/searchResult`);
  };
  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };

  const getOpeningDashboard = () => {
    const api = {
      functionName: "dashboardForOpening",
      site_id: userDetails[0].site_id,
    };
    backendApi(api).then((response) => {
      if (response.success === "1") {
        console.log(response, "respose_dashboardForOpening");

        setOpeningStatus();
        setVacancyReport(response.newArray);
        console.log("response", response);
      }
    });
  };
  // const rows = Array.from({ length: 10 });
  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />

      <div className="content-wrapper">

        <Header
          Header="Dashboard"
          toggleMenu={toggleMenu}
          menuClick={menuClick}
        />
        {!loader ?
          <div className="main-container">
            <div className="row">
              <div className="card main-card-box dashboard-boxes">
                <div className="card-body">
                  <ShimmerCategoryItem />
                  <ShimmerCategoryItem />
                  <ShimmerCategoryItem />
                  <ShimmerCategoryItem />
                  <ShimmerCategoryItem />
                </div>
              </div>
            </div>
           
          </div>
          :
          <>
            <div className="main-container">
              <div className="row">
                {/* <div
              className="col-xxl-2 col-lg-3 col-md-6"
              onClick={() => viewNewVacancy()}
            >
              <div className="card main-card-box">
                <div className="card-body">
                  <div className="box_splite">
                    <div className="left_splite">
                      <h3 className="box-head">CV Today</h3>

                      </div>
                    <div className="right_splite"> {
                                    dashboardData?.today_candidateCnt[0]
                                      .today_candidateCnt
                                  }</div>
                  </div>
                </div>
              </div>             
            </div> */}
                <div
                  className="col-xxl-2 col-lg-3 col-md-6 padding-left-right-change"
                  onClick={() => viewNewCandidate()}
                >
                  <div className="card main-card-box dashboard-boxes">
                    <div className="card-body">
                      <div className="box_splite">
                        <div className="left_splite">
                          <h3 className="box-head">Total CV Recieved</h3>
                          {/* <h2 className="box-subhead">
                    {
                        dashboardData?.last7daysCandidate[0]
                          .total_candidateCnt
                      }
                    </h2> */}
                        </div>
                        {/* <div className="right_splite">   <FaUserPlus /></div> */}
                        <div className="right_splite">
                          {dashboardData?.last7daysCandidate[0].total_candidateCnt}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {leftSide?.length > 0 && (
                  <>
                    {leftSide.map((status, index) => (
                      <div
                        className="col-xxl-2 col-lg-3 col-md-6 padding-left-right-change"
                        onClick={() => viewNewInterviews()}
                      >
                        <div className="card main-card-box dashboard-boxes">
                          <div className="card-body">
                            <div className="box_splite">
                              <div className="left_splite">
                                {" "}
                                <h3 className="box-head">{status.category_type}</h3>
                              </div>
                              <div className="right_splite"> {status.cnt}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-12 padding-left-right-change">
                  <div className="card main-card-box">
                    <div className="card-body">
                      {isAdminRole && (
                        <div className="barChartWrap">
                          <h4 className="dash-sub-head">
                            No of Openings by Status
                          </h4>
                          {categoriesApplication && seriesDataApplication && (
                            <BarChart2
                              categories={categoriesApplication}
                              seriesData={seriesDataApplication}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="card main-card-box">
                    <div className="card-body">
                      <div className="barChartWrap">
                        <h4 className="dash-sub-head">
                          No. Of Applicants Per Months
                        </h4>
                        {categories && seriesData && (
                          <BarChart
                            categories={categories}
                            seriesData={seriesData}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 padding-left-right-change">
                  <div className="card main-card-box">
                    <div className="card-body">
                      <div className="barChartWrap">
                        <h4 className="dash-sub-head">Requirement Analytics</h4>
                        <div className="table-responsive table-header-sticky">
                          <table className="table mb-0">
                            <thead>
                              <tr>
                                <th>Managers</th>
                                <th>Opening</th>
                                <th>Status</th>
                                <th>Dep / Project</th>
                                <th style={{ width: "30px" }}>Priority</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vacancyReport.map((openings, index) => {
                                let vacancyCount = openings.data.reduce(
                                  (total, obj) => total + obj.no_of_position,
                                  0
                                );
                                return (
                                  <tr key={`vacancyReport_${index}`}>
                                    <td>{openings.reportingManagers_name}</td>
                                    <td>{vacancyCount}</td>
                                    <td className="p-0" colSpan={3}>
                                      {openings.data.map((m, idx) => (
                                        <div key={`status_project_${idx}`} className="d-flex justify-content-between align-items-center mb-1">
                                          <div className="text-secondary small">
                                            {m.STATUS === "Open" && (
                                              <div className="text-secondary mb-1">
                                                <FiPlusCircle
                                                  className="me-2"
                                                  style={{ width: "14px", height: "14px" }}
                                                />
                                                Open - {m.no_of_position}
                                              </div>
                                            )}
                                            {m.STATUS === "Closed" && (
                                              <div className="text-success mb-1">
                                                <FiCheckCircle
                                                  className="me-2"
                                                  style={{ width: "14px", height: "14px" }}
                                                />
                                                Closed - {m.no_of_position}
                                              </div>
                                            )}
                                            {m.STATUS === "On Hold" && (
                                              <div className="text-primary mb-1">
                                                <FiClock
                                                  className="me-2"
                                                  style={{ width: "14px", height: "14px" }}
                                                />
                                                Processing - {m.no_of_position}
                                              </div>
                                            )}
                                            {m.STATUS === "Pending" && (
                                              <div className="text-warning mb-1">
                                                <FiXCircle
                                                  className="me-2"
                                                  style={{ width: "14px", height: "14px" }}
                                                />
                                                Pending - {m.no_of_position}
                                              </div>
                                            )}
                                          </div>
                                          <div className="text-info small">{m.project_name || 'N/A'}</div>
                                          <div className="text-success small"> <FcHighPriority className="me-2" />{m.priority}</div>
                                        </div>
                                      ))}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card main-card-box dashboard-boxes">
                    <div className="card-body">
                      {isAdminRole && (
                        <div className="barChartWrap">
                          <h4 className="dash-sub-head">Hiring Pipeline Summary</h4>
                          {categoriesCandidate && seriesDataCandidate && (
                            <BarChart6
                              categories={categoriesCandidate}
                              seriesData={seriesDataCandidate}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12 padding-left-right-change">
                  <div className="card main-card-box">
                    <div className="card-body">
                      {isAdminRole && (
                        <div className="barChartWrap">
                          <h4 className="dash-sub-head">
                            Applicants Received by Source
                          </h4>
                          {categoriesApplication && seriesDataApplication && (
                            <BarChart2
                              categories={categoriesApplication}
                              seriesData={seriesDataApplication}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-12 padding-left-right-change">
                  <div className="card main-card-box">
                    <div className="card-body">
                      <div className="barChartWrap">
                        <h4 className="dash-sub-head">Interview Activity</h4>
                        {categoriesInterview && seriesDataInterview && (
                          <BarChart4
                            categories={categoriesInterview}
                            seriesData={seriesDataInterview}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* {vacancyReport.length > 0 && (
              <div className="col-lg-12 col-md-12 padding-left-right-change">
                <div className="card main-card-box">
                  <div className="card-body">
                    <table className="table">
                      <thead>
                        <tr>
                          <th style={{ minWidth: "50px" }}>Opening Details</th>
                          <th style={{ minWidth: "50px" }}>Vacancies</th>
                          <th style={{ minWidth: "50px" }}>Due Date</th>
                          <th style={{ minWidth: "50px" }}>Recruiters</th>
                          <th style={{ minWidth: "50px" }}>Managers</th>
                          <th style={{ minWidth: "50px" }}>Status</th>
                          <th style={{ minWidth: "50px" }}>Due Date</th>
                        </tr>
                      </thead>
                      {vacancyReport.map((o) => {
                        const days = Math.abs(o?.no_of_day_due || 0);
                        const isOverdue = o?.no_of_day_due < 0;
                        return (
                          <tbody>
                            <tr>
                              <td aria-label="OpeningDetails" className="col-3">
                                <p
                                  style={{
                                    color: "blue",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                >
                                  {o?.recruitmentSummary.replace(
                                    /\\(['"])/g,
                                    "$1"
                                  )}
                                </p>
                                <p>
                                  {o?.projectName.replace(/\\(['"])/g, "$1")}
                                </p>
                                <p>{o?.locationName}</p>
                              </td>
                              <td className="col-1">
                                {o?.filled_vacancy}/{o?.no_of_vacancy}
                              </td>
                              <td className="col-2">
                                {moment(o?.due_date).format("DD-MM-YYYY")}
                              </td>
                              <td className="col-2">{o?.recruiters}</td>
                              <td className="col-2">{o?.reportingManagers}</td>
                              <td className="col-1">{o?.vacancyStatus}</td>
                              <td className="col-1">
                                {isOverdue ? (
                                  <span aria-label={`${days} days overdue`}>
                                    {days} days Overdue{" "}
                                    <FaExclamationCircle color="red" />
                                  </span>
                                ) : (
                                  <span aria-label={`Due in ${days} days`}>
                                    Due in {days} days{" "}
                                    <FaExclamationCircle color="green" />
                                  </span>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        );
                      })}
                    </table>
                  </div>
                </div>
                <div className="table-responsive"></div>
              </div>
            )} */}
              </div>
            </div>
          </>
        }

      </div>
    </div>
  );
}
